export default __webpack_public_path__ + "static/media/5005.6c784056.png";